<script lang="ts">
    import Background from "./Background.svelte";

    const jooo = new Audio("assets/jooo.wav");
    const graukasdrau = new Audio("assets/graukasdrau.wav");
    const jawoll = new Audio("assets/jawoll.wav");

    function playJooo() {
        jooo.play();
    }

    function playGraukasdrau() {
        graukasdrau.play();
    }

    function playJawoll() {
        jawoll.play();
    }
</script>

<Background />

<header><strong>graukas.dev</strong></header>

<main>
    <h1 on:click={playJooo}>graukas.dev</h1>
    <p>
        <img
            src="assets/graukas.png"
            alt="graukas © by tirolmilch.at"
            title="graukas © by tirolmilch.at"
            on:click={playGraukasdrau}
            on:mouseenter={playGraukasdrau}
        />
    </p>
    <p>
        <button on:click={playJawoll}>jawoll</button>
    </p>
</main>

<footer>
    <div />
    <div>
        developed with ❤️ &amp; <strong><em>graukas</em></strong> in tyrol.
    </div>
    <div>
        Special props to <a href="https://www.vonseitendergemeinde.at/">
            <strong>VSDG</strong>
        </a>
    </div>
</footer>

<style>
    main {
        text-align: center;
        max-width: 300px;
        margin: 0 auto;
    }

    h1 {
        color: #ff3e00;
        font-size: 3rem;
        font-weight: 100;
    }

    @media (min-width: 640px) {
        h1 {
            font-size: 4rem;
        }
    }
</style>
